export const REQUEST_INTEGRATIONS = 'dt/integrations/REQUEST_INTEGRATIONS';
export const CREATE_INTEGRATION = 'dt/integrations/CREATE_INTEGRATION';
export const CREATE_INTEGRATION_TEMPLATE = 'dt/integrations/CREATE_INTEGRATION_TEMPLATE';
export const UPDATE_INTEGRATION = 'dt/integrations/UPDATE_INTEGRATION';
export const UPDATE_INTEGRATION_TEMPLATE = 'dt/integrations/UPDATE_INTEGRATION_TEMPLATE';
export const DELETE_INTEGRATION = 'dt/integrations/DELETE_INTEGRATION';
export const RECEIVE_INTEGRATIONS = 'dt/integrations/RECEIVE_INTEGRATIONS';
export const RECEIVE_INTEGRATION_TEMPLATES = 'dt/integrations/RECEIVE_INTEGRATION_TEMPLATES';
export const RECEIVE_INTEGRATION = 'dt/integrations/RECEIVE_INTEGRATION';
export const REMOVE_INTEGRATION = 'dt/integrations/REMOVE_INTEGRATION';
export const SYNC_REMOTE_ASSETS = 'dt/integrations/SYNC_REMOTE_ASSETS';
export const CREATE_REMOTE_EVENT = 'dt/integrations/CREATE_REMOTE_EVENT';

export const requestIntegrations = (query) => ({
  type: REQUEST_INTEGRATIONS,
  query,
});

export const createIntegration = (data) => ({
  type: CREATE_INTEGRATION,
  data,
});

export const createIntegrationTemplate = (data) => ({
  type: CREATE_INTEGRATION_TEMPLATE,
  data,
});

export const updateIntegration = (id, data) => ({
  type: UPDATE_INTEGRATION,
  id,
  data,
});

export const updateIntegrationTemplate = (id, data) => ({
  type: UPDATE_INTEGRATION_TEMPLATE,
  id,
  data,
});

export const deleteIntegration = (id) => ({
  type: DELETE_INTEGRATION,
  id,
});

export const receiveIntegrations = (integrations, integrationTypes, loadedScope) => ({
  type: RECEIVE_INTEGRATIONS,
  integrations,
  integrationTypes,
  loadedScope,
});

export const receiveIntegrationTemplates = (templates) => ({
  type: RECEIVE_INTEGRATION_TEMPLATES,
  templates,
});

export const receiveIntegration = (integration) => ({
  type: RECEIVE_INTEGRATION,
  integration,
});

export const removeIntegration = (id) => ({
  type: REMOVE_INTEGRATION,
  id,
});

export const syncRemoteAssets = (integrationId, siteId, callback = () => null) => ({
  type: SYNC_REMOTE_ASSETS,
  integrationId,
  siteId,
  callback,
});

export const createRemoteEvent = (integrationType, data) => ({
  type: CREATE_REMOTE_EVENT,
  integrationType,
  data,
});
